/* jshint ignore:start */
import React, { Component } from "react";

class SearchBar extends Component {
  
  state = { value: "" };

  onChangeHandler = (event) => {
    this.setState({ value: event.target.value });
  };

  onSubmitHandler = (event) => {
    event.preventDefault();
    this.props.submitHandler(this.state.value);
  };
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <form onSubmit={this.onSubmitHandler}>
            <div className="form-group">
              <label>
                <b>Image Search</b>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Search Keywords"
                value={this.state.value}
                onChange={this.onChangeHandler}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default SearchBar;
